module.exports = __webpack_public_path__ + "img/1569710591.7c64bfd6.jpg";